import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const AssetTypeEnum = z.enum(['Image', 'Video'])
export type AssetType = z.infer<typeof AssetTypeEnum>

export const AssetItemSchema = buildEntrySchemaFor('assetItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      heading: RichTextSchema,
      description: RichTextSchema,
      assetType: AssetTypeEnum,
      optionImage: AssetSchema.optional(),
      optionVideo: AssetSchema.optional(),
      optionPoster: AssetSchema.optional(),
    }),
  ),
})
export type AssetItem = z.infer<typeof AssetItemSchema>
